"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var WickedApiClient_1 = require("../api/WickedApiClient");
var i0 = require("@angular/core");
var i1 = require("../api/WickedApiClient");
var SubscribtionService = /** @class */ (function () {
    function SubscribtionService(subscribtionClient) {
        this.subscribtionClient = subscribtionClient;
    }
    SubscribtionService.prototype.create = function (subscribe) {
        return this.subscribtionClient.create(subscribe).toPromise();
    };
    SubscribtionService.prototype.cancel = function (subscribtionId) {
        return this.subscribtionClient.cancelSubscribtion(subscribtionId).toPromise();
    };
    SubscribtionService.prototype.hasUserSubscribtion = function () {
        return this.subscribtionClient.hasUserSubscribtion().toPromise();
    };
    SubscribtionService.prototype.get = function () {
        return this.subscribtionClient.subscribtionData().toPromise();
    };
    SubscribtionService.prototype.createPremiumAdToken = function (data) {
        return this.subscribtionClient.createPremiumAdToken(data).toPromise();
    };
    SubscribtionService.prototype.GetUserPremiumAdTokens = function () {
        return this.subscribtionClient.getUserPremiumAdTokens().toPromise();
    };
    SubscribtionService.prototype.createWriteAdToken = function (data) {
        return this.subscribtionClient.createWriteAdToken(data).toPromise();
    };
    SubscribtionService.prototype.createThirdPartyAdToken = function (data) {
        return this.subscribtionClient.createThirdPartyAdToken(data).toPromise();
    };
    SubscribtionService.prototype.GetUserThirdPartyAdTokens = function () {
        return this.subscribtionClient.getUserThirdPartyAdTokens().toPromise();
    };
    SubscribtionService.prototype.getWriteAdToken = function () {
        return this.subscribtionClient.getWriteAdToken().toPromise();
    };
    //baner
    SubscribtionService.prototype.createBanerAdvertising = function (data) {
        return this.subscribtionClient.createBanerAdvertising(data).toPromise();
    };
    SubscribtionService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function SubscribtionService_Factory() { return new SubscribtionService(i0.ɵɵinject(i1.SubscribtionClient)); }, token: SubscribtionService, providedIn: "root" });
    return SubscribtionService;
}());
exports.SubscribtionService = SubscribtionService;
